import { memo } from "react";
import Service, { type ServiceProps } from "../Service";
import AdditionalOptions from "./AdditionalOptions";

const PhoneVerification = (props: Omit<ServiceProps, 'serviceLabel'>) => (
    <Service
        {...props}
        serviceLabel='Phone Verification'
        additionalOptionsSlot={(
            <AdditionalOptions />
        )}
    />
);

export default memo(PhoneVerification);
